var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("assignee-select", {
    key: "assignees-select",
    ref: "assigneeSelect",
    staticClass: "w-auto",
    attrs: {
      assignees: _vm.localValue || [],
      "inline-edit": _vm.readOnly,
      "read-only": _vm.readOnly,
      board: _vm.boardId,
      multiple: _vm.multiple,
      "avatar-container-class": "mt-0",
      "time-line-item-card": true,
    },
    on: { change: _vm.handleNotifyChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }